import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'How long does a balayage appointment take in Vancouver?',
      answer:
        'A balayage appointment typically takes 2.5 to 4 hours, depending on your hair length, density, and the complexity of the colour. First-time balayage clients or those going significantly lighter may need closer to 4 hours to achieve the best result.',
    },
    {
      question: 'How much does balayage cost in Vancouver?',
      answer:
        'Pricing varies based on hair length, your starting colour, complexity of the service, and whether toning or a treatment is included. For the most accurate, up-to-date pricing, please view our live service menu and book directly on Fresha — a complimentary consultation is included.',
    },
    {
      question: 'Can I get balayage on dark or black hair?',
      answer:
        'Yes — balayage works beautifully on dark hair, though it may require a pre-lightening step to achieve lighter tones. Dark-to-light balayage is one of the most dramatic and popular transformations, and an experienced colourist can achieve it while maintaining hair health.',
    },
    {
      question: 'How often do I need to touch up balayage?',
      answer:
        "Most balayage clients return every 10–16 weeks for a refresh. Unlike traditional highlights, the grow-out is intentional and natural-looking, so there's no urgency to rush back in. A toner refresh at 6–8 weeks can help maintain vibrancy between full appointments.",
    },
    {
      question: 'Where is the best place to get balayage in Vancouver?',
      answer:
        "Prép Beauty Parlour at 1305 Burrard St is one of downtown Vancouver's most trusted salons for balayage, with a 4.7 star rating and 400+ reviews from local clients across Downtown Vancouver, the West End, Yaletown, Davie Village, and Kitsilano. Our colour specialists use freehand painting techniques to create natural, dimensional results tailored to each client's hair type, skin tone, and lifestyle.",
    },
    {
      question: 'What is the difference between balayage and highlights in Vancouver salons?',
      answer:
        "Balayage and traditional highlights are both lightening techniques, but the result looks very different. Highlights use foils to lift hair in uniform sections from root to tip, creating a more structured, consistent colour. Balayage is painted freehand onto the surface of sections, concentrated toward the mid-lengths and ends — mimicking how the sun naturally lightens hair. The result is softer, more dimensional, and grows out far more naturally than foil highlights. At Prép Beauty Parlour in downtown Vancouver, most clients who switch from highlights to balayage don't look back.",
    },
    {
      question: 'What is California balayage and can I get it in Vancouver?',
      answer:
        'California balayage — sometimes called "California blonde" — refers to a bright, sun-drenched, heavily lightened balayage look inspired by beachy West Coast hair. It typically involves significant lift, often with a pre-lightening step, to achieve that lived-in blonde effect. Yes, you can absolutely get it in Vancouver. At Prép Beauty Parlour on Burrard St, our colourists are experienced with high-lift balayage and can customize the placement and tone to suit your natural hair colour and skin tone.',
    },
    {
      question: 'Is balayage good for fine or thin hair?',
      answer:
        'Yes — balayage is actually one of the most flattering techniques for fine or thin hair. Because the colour is painted on the surface rather than woven from root to tip, it adds the illusion of depth and dimension without the heaviness that full foil highlights can create. A skilled colourist will place the lightness strategically to make fine hair look fuller and more textured. At Prép, we assess your hair density and texture during the consultation before recommending the best colour approach.',
    },
    {
      question: 'Can I get balayage if I have previously coloured or chemically treated hair?',
      answer:
        'In most cases, yes — but a consultation is essential. Previously coloured hair (especially box dye or previously highlighted hair) may respond differently to lightener, and a colour correction step may be needed first. Chemically treated hair (permed, relaxed, or keratin-treated) also requires extra care during the lightening process. At Prép Beauty Parlour, every new colour client receives a complimentary consultation so we can assess your hair history and give you an honest recommendation before any work begins.',
    },
    {
      question: 'How do I maintain balayage colour between appointments in Vancouver?',
      answer:
        'Balayage is one of the most low-maintenance colour services available — but a few habits keep it looking fresh longer. Use a sulfate-free, colour-safe shampoo and a hydrating conditioner or mask weekly (lightened hair is more porous). A purple or blue toning shampoo once a week will neutralize any brassiness in blonde tones. Avoid excessive heat without a protectant, and limit sun exposure if you want to preserve your toner. Most Prép clients find a toner refresh at 6–8 weeks and a full appointment every 12–16 weeks keeps their colour in ideal condition.',
    },
    {
      question: 'Do you offer balayage for men in Vancouver?',
      answer:
        "Yes — balayage isn't just for long hair or women's cuts. Men's balayage (sometimes called \"mbalayage\") creates natural-looking sun-kissed texture and dimension on shorter styles. It's especially popular on textured, wavy, or curly men's hair. At Prép Beauty Parlour in downtown Vancouver, our colour team regularly works with male clients looking for subtle to bold colour enhancement.",
    },
    {
      question: 'How do I book a balayage appointment at Prép Beauty Parlour in Vancouver?',
      answer:
        "The easiest way to book is online through Fresha — you can view real-time availability, select your service, and confirm your appointment without having to call. If you're new to the salon or unsure which colour service is right for you, select the consultation option and one of our colourists will walk you through the best approach for your hair. We're located at 1305 Burrard St, Vancouver, just steps from the Burrard SkyTrain station. You can also call us at (604) 764-6452 during business hours.",
    },
  ];

  return (
    <section id="faq" className="section-padding bg-gradient-to-b from-black via-[#0f0f0f] to-black relative">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#d4af37] text-sm font-semibold tracking-[0.2em] uppercase">FAQ</span>
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-light text-[#f5f5f0] mb-6">
            Frequently Asked
            <span className="block text-[#d4af37]">Questions</span>
          </h2>
          <p className="text-[#f5f5f0]/70 text-lg">
            Everything you need to know about balayage in Vancouver
          </p>
        </div>

        <div className="bg-gradient-to-br from-[#1a1a1a] to-black border border-[#d4af37]/30 p-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-[#d4af37]/20">
                <AccordionTrigger data-testid={`faq-trigger-${index}`} className="text-left text-[#f5f5f0] hover:text-[#d4af37] transition-colors text-lg font-medium py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${index}`} className="text-[#f5f5f0]/70 leading-relaxed pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-12 text-center bg-gradient-to-r from-transparent via-[#d4af37]/10 to-transparent py-8">
          <p className="text-[#f5f5f0]/70 mb-4">Have more questions?</p>
          <button
            data-testid="faq-contact-cta"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="text-[#d4af37] hover:text-[#b8941f] font-medium transition-colors underline underline-offset-4"
          >
            Contact us for personalized advice
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
